import { useQuery } from "@apollo/client";
import React, { useContext, useState } from "react";
import { Table } from "src/components/layout/tables/Table";
import { PaginationOffset } from "src/components/pagination/PaginationOffset";
import { BreadCrumbProp, BreadCrumb } from "../../../../components/light/Breadcrumb";
import { Content } from "../../../../components/light/Content";
import { SectionBlock } from "../../../../components/light/SectionBlock";
import { Loading } from "../../../../components/Loading";
import { ContextUser } from "../../../../context/ContextUser";
import { Graphql } from "../../../../graphql/_graphql";

const BreadCrumbItems: BreadCrumbProp[] = [
  {
    text: "Applications",
    to: "#",
  },
  {
    text: "Products",
    to: "#",
  },
  {
    text: "Review",
    to: "/review",
  },
];

export function ProductReviewScreen(props: any) {
  const context = useContext(ContextUser);
  const [sort, setSort] = useState("DATE");
  const [offset, setOffset] = useState(0);
  const [code, setCode] = useState("");
  const [codeInput, setCodeInput] = useState("");
  const [sortOrder, setSortOrder] = useState("DESC");
  const { data, loading } = useQuery(Graphql.Query.QUERY_PRODUCT_REVIEW_LIST, {
    fetchPolicy: "no-cache",
    variables: {
      merchantId: Number(context.merchant.id!),
      offset: Number(offset) * 6,
      limit: 6,
      productCode: code,
      sortBy: sort,
      sortOrder,
    },
  });

  if (loading || data === undefined) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <div className="row">
          <div className="col-md-6">
            <SectionBlock title="Customer Review Product" transparent={true}>
              <Loading />
            </SectionBlock>
          </div>
        </div>
      </Content>
    );
  }

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-6">
          <SectionBlock title="Customer Review Product" transparent={true}>
            <div className="row">
              <div className="col-md-2">
                <select
                  className="form-control"
                  value={sort}
                  onChange={(e) => {
                    setSort(e.target.value);
                  }}
                >
                  <option value="RATING">Rating</option>
                  <option value="DATE">Date</option>
                </select>
              </div>
              <div className="col-md-2">
                <select className="form-control" value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
                  <option value="ASC">A-Z</option>
                  <option value="DESC">Z-A</option>
                </select>
              </div>
              <div className="col-md-5"></div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="search code..."
                  value={codeInput}
                  onChange={(e) => setCodeInput(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      setCode(codeInput);
                    }
                  }}
                />
              </div>
            </div>
            <br />
            <Table stripe border grid seperator>
              <thead>
                <tr>
                  <th>Item</th>
                  <th className="text-center">Rate</th>
                  <th>Comment</th>
                  <th className="text-right">Review By</th>
                </tr>
              </thead>
              <tbody>
                {data.productReviewList.map((x: any, i: number) => {
                  return (
                    <tr key={i}>
                      <td>
                        {x.product && (
                          <a
                            href={`https://www.l192.com/product/${x.product.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={x.product.thumbnail}
                              alt=""
                              style={{
                                width: 50,
                                height: 50,
                                borderRadius: 4,
                                objectFit: "cover",
                              }}
                            />
                            <small className="ml-3">{x.product.code}</small>
                          </a>
                        )}
                      </td>
                      <td className="text-center">
                        {[...new Array(5)].map((rate: any, j: number) => {
                          return (
                            <i
                              className="fas fa-star"
                              key={j}
                              style={{
                                color: j < Number(x.rating) ? "#ffe623" : "#666",
                              }}
                            ></i>
                          );
                        })}
                      </td>
                      <td style={{ width: 350 }}>
                        <span style={{ color: "#666" }}>{x.comment}</span>
                      </td>
                      <td className="text-right">
                        <span>{x.customer.name}</span>
                        <br />
                        <small>{x.createdAt}</small>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <br />
            <nav>
              <PaginationOffset {...props} onPage={(p: any) => setOffset(p - 1)} />
            </nav>
          </SectionBlock>
        </div>
      </div>
    </Content>
  );
}
